export default __webpack_public_path__ + "static/media/4.5859b812.png";